export interface List1ItemDto {
    code1: string;
    description: string;
}

export interface List2ItemDto {
    code2: string;
    description: string;
}

export interface List3ItemDto {
    code3: string;
    description: string;
}

export const list1Data: List1ItemDto[] = [
    { code1: 'C1_I1', description: 'List 1 Item 1' },
    { code1: 'C1_I2', description: 'List 1 Item 2' },
    { code1: 'C1_I3', description: 'List 1 Item 3' },
    { code1: 'C1_I4', description: 'List 1 Item 4' },
    { code1: 'C1_I5', description: 'List 1 Item 5' },
    { code1: 'C1_I6', description: 'List 1 Item 6' },
    { code1: 'C1_I7', description: 'List 1 Item 7' },
    { code1: 'C1_I8', description: 'List 1 Item 8' }
]

export const list2Data: List2ItemDto[] = [
    { code2: 'C2_I1', description: 'List 2 Item 1' },
    { code2: 'C2_I2', description: 'List 2 Item 2' },
    { code2: 'C2_I3', description: 'List 2 Item 3' },
    { code2: 'C2_I4', description: 'List 2 Item 4' },
    { code2: 'C2_I5', description: 'List 2 Item 5' },
    { code2: 'C2_I6', description: 'List 2 Item 6' }
]

export const list3Data: List3ItemDto[] = [
    { code3: 'C3_I1', description: 'List 3 Item 1' },
    { code3: 'C3_I2', description: 'List 3 Item 2' },
    { code3: 'C3_I3', description: 'List 3 Item 3' },
    { code3: 'C3_I4', description: 'List 3 Item 4' }
]
